import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import logo from '../../images/logo.png'
import loaderImg from '../../images/loader.png'

import './loader.css'

const useStyles = makeStyles((theme) => ({
  
}));

const Loader = (props) => {
  return (
    <div style={{display:props.loaderDisplay}}>
      <div className="loaderroot pb-3">
        <div className="text-light position-relative" style={{minWidth: 120}}>
          <img src={loaderImg} alt="logo" className="loaderimgs img-fluid" />
          <img src={logo} alt="logo" className="laoderlogo img-fluid mb-3" />
          <br />
          <p className="mt-5 pt-2">Loading...</p>
        </div>
      </div>
    </div>
  );
}


export default Loader;
